// removed by extract-text-webpack-plugin
module.exports = {"filtersWrap":"style__filtersWrap___1aR-v","withResults":"style__withResults___2Hw_B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchFullscreen/Filters/style.scss
// module id = 1380
// module chunks = 0